import { Box, Button } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

export default function FilterButton({
  filters,
  isOpen,
  onToggleOpen,
  onClearAll,
}) {
  const activeFilterCount = Object.values(filters).reduce(
    (sum, selection) => sum + Object.keys(selection).length,
    0,
  );

  const styles = {
    toggleRow: {
      display: "flex",
      alignItems: "center",
      minHeight: 40,
    },
    toggleBtn: {
      color: "background.tableHeaderText",
      fontWeight: 500,
      fontSize: "0.8125rem",
      textTransform: "none",
    },
    clearBtn: {
      color: "background.tableHeaderText",
      fontWeight: 500,
      textTransform: "none",
      opacity: 0.8,
    },
    clearBtnHidden: { visibility: "hidden" },
    countBadge: { ml: 0.5 },
    countBadgeHidden: { visibility: "hidden" },
    toggleIcon: {
      transition: "transform 0.15s",
      position: "relative",
      top: -0.5,
    },
    toggleIconOpen: { transform: "rotate(180deg)" },
    toggleIconClosed: { transform: "rotate(0deg)" },
  };

  return (
    <Box sx={styles.toggleRow}>
      <Button
        onClick={onToggleOpen}
        size="small"
        sx={styles.toggleBtn}
        startIcon={
          <ExpandMore
            fontSize="small"
            sx={[
              styles.toggleIcon,
              isOpen ? styles.toggleIconOpen : styles.toggleIconClosed,
            ]}
          />
        }
      >
        Filter
        <Box
          component="span"
          sx={[
            styles.countBadge,
            activeFilterCount === 0 && styles.countBadgeHidden,
          ]}
        >
          ({activeFilterCount || 1})
        </Box>
      </Button>
      <Button
        size="small"
        onClick={onClearAll}
        sx={[styles.clearBtn, activeFilterCount === 0 && styles.clearBtnHidden]}
      >
        Clear all
      </Button>
    </Box>
  );
}
